export enum Ad {
	Web = 1,
	WebDescription  = <any>'Página de internet del movimiento',

	School = 2,
	SchoolDescription  = <any>'Escuela de los hijos',

	Job = 3,
	JobDescription  = <any>'Empresa en donde trabaja',

	OtherGroup = 4,
	OtherGroupDescription  = <any>'Otro movimiento',

	Fcbk = 5,
	FcbkDescription  = <any>'Facebook',

	Church = 6,
	ChurchDescription  = <any>'Iglesia',

	Triptych = 7,
	TriptychDescription  = <any>'Volante o tríptico',

	Friends = 8,
	FriendsDescription  = <any>'Amistades o familiares',

	Radio = 9,
	RadioDescription  = <any>'Estación de radio',

	Group = 10,
	GroupDescription  = <any>'Integrantes del movimiento',

	Other = 11,
	OtherDescription  = <any>'Otra forma',
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/enums/ad.enum.ts